<template>
    <div :class="[$style.__banner]" >
        <img :src="src">
    </div>
</template>

<script>
module.exports = {
    data() {
        return {
            src : process.env.NODE_ENV == 'local' ? require('@/medias/images/banner/banner.png') : process.env.VUE_APP_STORAGE + '/vue/img/banner.6ab828dc.png'
        }
    },
    created () {
        
    }
}
</script>

<style scoped module lang="scss">
    .__banner {
        img {
            width : 100%;
        }
    }
</style>